var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row d-flex justify-content-center p-0 m-0"},[_c('b-card',{staticClass:"cardDash p-0 justify-content-end"},[_c('div',{staticClass:"d-flex justify-content-end"},[_c('h6',{staticClass:"btn-close flo",on:{"click":_vm.toDash}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }